// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");

function user_email(t) {
  return t.user_email;
}

function fromJson(json) {
  return {
          user_email: Json_decode.field("user", (function (param) {
                  return Json_decode.field("email", Json_decode.string, param);
                }), json)
        };
}

var activityType = "reopen";

exports.activityType = activityType;
exports.user_email = user_email;
exports.fromJson = fromJson;
/* No side effect */
